/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Reason_PackingInputs */

const vi_warehouse_defects_reason_packing = /** @type {(inputs: Warehouse_Defects_Reason_PackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi đóng gói`)
};

/**

* @param {Warehouse_Defects_Reason_PackingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_reason_packing = /** @type {((inputs?: Warehouse_Defects_Reason_PackingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Reason_PackingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_reason_packing(inputs)
});